<template>
  <div
    class="alert-screen-size absolute top-0 z-[100000] hidden h-full w-full items-center justify-center"
  >
    <span class="p-8 text-center text-xl text-white"
      >Bitte verwenden Sie einen größeren Bildschirm, um <b>INFRA|Wärme</b> zu
      nutzen.</span
    >
  </div>
</template>

<style scoped lang="scss">
.alert-screen-size {
  background: linear-gradient(
    257.82deg,
    rgb(0, 18, 87) -12.99%,
    rgb(6, 146, 188) 117.03%
  );
  @media screen and (max-width: 767px) {
    display: inline-flex !important;
  }
}
</style>
